import React from "react";
import { Table, Skeleton } from "antd";
const OrderDetailProductTable = (props) => {
  const orderDetailColumns = [
    {
      title: "Images",
      render: (image) => {return image?(<img alt="Profile Image" src={image} />):(<Skeleton.Image active />)},
      dataIndex: "image",
      key: "image",
    },
    { title: "Items", dataIndex: "name", key: "name", },
    { title: "Quantity", dataIndex: "quantity", key: "quantity", },
    // { title: "Volume (L)", dataIndex: "volume" },
    // { title: "Weight(KG)", dataIndex: "weight" },
    { title: "Price", dataIndex: "price", key: "price", },
  ];
  return (
    <Table
      dataSource={(props.orderData && props.orderData[0] && props.orderData[0].order_details.order_items) &&  props.orderData[0].order_details.order_items}
      columns={orderDetailColumns}
      pagination={false}
    />
  );
};
export default OrderDetailProductTable;
